var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcAddUserBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.706 326.294C399.566 300.154 368.452 280.803 334.505 269.089C370.863 244.048 394.75 202.139 394.75 154.75C394.75 78.2434 332.507 16 256 16C179.493 16 117.25 78.2434 117.25 154.75C117.25 202.139 141.137 244.048 177.496 269.089C143.549 280.803 112.435 300.154 86.2947 326.294C40.9647 371.625 16 431.894 16 496H53.5C53.5 384.341 144.341 293.5 256 293.5C367.659 293.5 458.5 384.341 458.5 496H496C496 431.894 471.035 371.625 425.706 326.294ZM256 256C200.171 256 154.75 210.58 154.75 154.75C154.75 98.92 200.171 53.5 256 53.5C311.829 53.5 357.25 98.92 357.25 154.75C357.25 210.58 311.829 256 256 256Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddUserBold);
export default __webpack_public_path__ + "static/media/ic-add-user-bold.e285651566891e395b94b6aba31488fe.svg";
export { ForwardRef as ReactComponent };